import React, { useMemo, useState, useEffect } from "react";
import Loader from "../../components/common/loader";
import { Card, CardBody, CardHeader, Container, Row } from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import TableContainer from "../../components/common/tableContainer";
import { getId } from "../../utils/helpers/custom";
import { Link } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { listOfSeniorTaskSheet } from "../../api/tasksheetApi";
import { CommonLabel, dateFormat } from "../../utils/helpers/common";
import { TaskLabel } from "../../common/constant/Task";
import NoResultsMessage from "../../components/noResultMessage";

const TaskSheet = () => {
  document.title = TaskLabel.Tasksheet;
  const id = getId();
  const [loading, setloading] = useState(false);
  const [listOfTaskSheet, setListOfTaskSheet] = useState([]);

  useEffect(() => {
    setloading(true);
    listOfSeniorTaskSheet({
        addedBy: id,
    })
      .then((res) => {
        setListOfTaskSheet(res?.data?.data?.listOfSeniorTaskSheet);
        setloading(false);
      })
      .catch((err) => setloading(false));
  }, []);

  const QueryColumns = useMemo(() => [
    {
      Header: CommonLabel.SrNo,
      filterable: false,
      Cell: ({ row }) => row?.index + 1,
    },
    {
      Header: TaskLabel.ProjectName,
      accessor: "projectName",
      filterable: false,
    },
    {
      Header: TaskLabel.TaskName,
      accessor: "taskName",
      filterable: false,
    },
    {
      Header: TaskLabel.TaskDetail,
      accessor: "taskDetails",
      filterable: false,
    },
    {
      Header: TaskLabel.DeveloperName,
      accessor: `authUser.developerName`,
      filterable: false,
    },
    {
      Header: TaskLabel.EstimateTime,
      accessor: "estimateTime",
      Cell: (items) => {
        return (
          <div>{`${items.row.original.hours}:${items.row.original.minutes}:00`}</div>
        );
      },
      filterable: false,
    },
    {
      Header: TaskLabel.StartDate,
      accessor: "startDate",
      filterable: false,
      Cell: (items) => {
        return <div>{dateFormat(items.row.original.startDate)}</div>;
      },
    },
    {
      Header: TaskLabel.EndDate,
      accessor: "endDate",
      filterable: false,
      Cell: (items) => {
        return <div>{dateFormat(items.row.original.endDate)}</div>;
      },
    },
    {
      Header: CommonLabel.Action,
      Cell: (cellProps) => {
        return (
          <div>
            <div className="hstack gap-2">
              <ReactTooltip
                place="bottom"
                variant="info"
                content={TaskLabel.EditTasksheet}
                anchorId={`editAction-${cellProps.row.index}`}
              />
              <Link
                to={`/tasksheet/edit-tasksheet/${cellProps?.row?.original?.id}`}
                className="btn btn-sm btn-soft-info edit-list"
                id={`editAction-${cellProps.row.index}`}
              >
                <i className="ri-pencil-fill align-bottom" />
              </Link>
              <ReactTooltip
                place="bottom"
                variant="info"
                content={TaskLabel.ViewTasksheet}
                anchorId={`viewAction-${cellProps.row.index}`}
              />
            </div>
          </div>
        );
      },
    },
  ]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={TaskLabel.Tasksheet} pageTitle="HRMS" />
        <Row className="mb-2">
          <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
            <h5 className="fw-semibold mt-2">{TaskLabel.Tasksheet}</h5>
          </div>
          <div className="col-auto order-2 order-sm-3 ms-auto">
            <div className="hstack gap-2">
              <Link to={"/tasksheet/add-tasksheet"} className="btn btn-primary">
                {" "}
                + {TaskLabel.AddTasksheet}
              </Link>
            </div>
          </div>
        </Row>
        <Card>
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">
              {TaskLabel.TasksheetList}
            </h4>
          </CardHeader>

          <CardBody>
            {listOfTaskSheet?.length || loading ? (
              <TableContainer
                columns={QueryColumns}
                data={listOfTaskSheet}
                isAddUserList={false}
                tableLoader={loading}
                customPageSize={5}
                divClass="table-responsive table-card mb-1 "
                tableClass="align-middle table-wrap"
                theadClass="table-light text-muted"
              />
            ) : (
              <NoResultsMessage />
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TaskSheet;
